// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Message-Message-module__IconContainer";
var _2 = "webpack-components-core-Message-Message-module__Message";
var _3 = "webpack-components-core-Message-Message-module__MessageContainer";
var _4 = "webpack-components-core-Message-Message-module__MessageControls";
var _5 = "webpack-components-core-Message-Message-module__MessageIcon";
var _6 = "webpack-components-core-Message-Message-module__danger";
var _7 = "webpack-components-core-Message-Message-module__info";
var _8 = "webpack-components-core-Message-Message-module__lg";
var _9 = "webpack-components-core-Message-Message-module__md";
var _a = "webpack-components-core-Message-Message-module__primary";
var _b = "webpack-components-core-Message-Message-module__prominent";
var _c = "webpack-components-core-Message-Message-module__sm";
var _d = "webpack-components-core-Message-Message-module__subtle";
var _e = "webpack-components-core-Message-Message-module__success";
var _f = "webpack-components-core-Message-Message-module__warning";
export { _1 as "IconContainer", _2 as "Message", _3 as "MessageContainer", _4 as "MessageControls", _5 as "MessageIcon", _6 as "danger", _7 as "info", _8 as "lg", _9 as "md", _a as "primary", _b as "prominent", _c as "sm", _d as "subtle", _e as "success", _f as "warning" }
